import React, { useEffect, useState } from "react";
import ApiService from "../../services/api-service";
import Loader from "../../components/Loader";
import VideoBox from "../VideoBox";

export default function VideoList({ studioId, onVideoSelect, isOwner }) {
  const [recordings, setRecordings] = useState([]);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, [studioId, pageNo]);

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    await Promise.all([fetchRecordings(pageNo), fetchVideos()])
      .then(() => setLoading(false))
      .catch(() => setError("Error loading data. Please try again."));
  };

  const fetchRecordings = async (page) => {
    try {
      const response = await ApiService.RECORDINGS(`studioId=${studioId}&pageNo=${page}&pageSize=16`);
      if (response.result?.length > 0) {
        setRecordings((prevRecordings) => [...prevRecordings, ...response.result]);
        setLoaded(response.result.length < 16);
      } else {
        setLoaded(true);
      }
    } catch {
      setError("Error fetching recordings. Please try again.");
    }
  };

  const fetchVideos = async () => {
    try {
      const response = await ApiService.VIDEO_USER(studioId);
      if (response?.result?.length > 0) {
        const formattedVideos = response.result.map((item) => ({
          _id: item._id,
          url: item.video.url,
          thumbnailImg: item.thumbnail.url,
          title: item.title,
          duration: item.duration,
          createdAt: item.createdAt,
        }));
        setVideos(formattedVideos);
      } else {
        setVideos([]);
      }
    } catch {
      setError("Error fetching videos. Please try again.");
    }
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 50 && !loading && !loaded) {
      setPageNo((prevPage) => prevPage + 1);
    }
  };

  const handleOpenMedia = (media) => {
    onVideoSelect(media.url);
  };

  return (
    <div className="video-list-container" style={{ paddingTop: "30px" }} onScroll={handleScroll}>
      {loading && <Loader />}
      {error && <div className="error-message">{error}</div>}

      {/* Section for Recordings */}
      <h2 style={{ fontSize: "30px", fontWeight: "bold" }}>Live Streams</h2>
      <div className="recordings-row" style={{ display: "flex", overflowX: "auto", gap: "16px", padding: "10px 0", flexWrap: "nowrap" }}>
        {recordings.length > 0 && recordings.map((recording) => (
          <VideoBox
            className="video-box"
            studioId={studioId}
            key={recording._id}
            video={recording}
            type="recording"
            onClick={() => handleOpenMedia(recording)}
            isOwner={isOwner}
            style={{ flexShrink: 0, flexGrow: 0, minWidth: "200px", width: "200px", maxWidth: "200px" }}
          />
        ))}
      </div>

      {/* Section for Videos */}
      <h2 style={{ fontSize: "30px", fontWeight: "bold" }}>Videos</h2>
      <div className="videos-row" style={{ display: "flex", overflowX: "auto", gap: "16px", padding: "10px 0", flexWrap: "nowrap" }}>
        {videos.length > 0 && videos.map((video) => (
          <VideoBox
            className="video-box"
            studioId={studioId}
            key={video._id}
            video={video}
            type="video"
            onClick={() => handleOpenMedia(video)}
            isOwner={isOwner}
            style={{ flexShrink: 0, flexGrow: 0, minWidth: "200px", width: "200px", maxWidth: "200px" }}
          />
        ))}
      </div>
    </div>
  );
}
